module.exports = __webpack_public_path__ + "img/fuwattbrat.074acd90.png";